export const getVehicleTypeCategory = (vehicleType) => {
  if (!vehicleType) return "OTROS";

  const normalizedType = vehicleType.trim().toUpperCase();

  if (
    normalizedType.includes("TRACTOCAMION") ||
    normalizedType === "TRACTO CAMION" ||
    normalizedType === "TRACTO"
  )
    return "TRACTOCAMION";
  if (
    normalizedType.includes("DOBLE TROQUE") ||
    normalizedType.includes("DOBLETROQUE")
  )
    return "DOBLE TROQUE";
  if (normalizedType.includes("TURBO")) return "TURBO";
  if (normalizedType.includes("CAMIONETA") || normalizedType === "CAMION")
    return "CAMIONETA";
  if (
    normalizedType.includes("CAMA ALTA") ||
    normalizedType === "CAMAALTA" ||
    normalizedType === "CAMA-ALTA"
  )
    return "CAMA ALTA";

  return "OTROS";
};

// Lista de placas requeridas para filtro específico
export const REQUIRED_PLATES = [
  "KUL721", "LQK483", "LQO444", "NEJ302", "SMT218", 
  "SNR176", "SNV282", "SPD532", "SPL340", "SPU446",
  "SQW215", "SRE020", "SVP181", "SWK941", "SXS188", 
  "SXS777", "SXS915", "SXT108", "SZY758", "TAL162",
  "TAL962", "TEK934", "THK636", "THS457", "TJB052", 
  "TJX012", "TLM770", "TRJ165", "TSX828", "TTR900",
  "TTT814", "TTX020", "VZI336", "WCU081", "WFL154", 
  "WFL472", "WHX462", "WHX477", "WHX571", "WHX585",
  "WLV937", "WLW231", "XPK198", "ZNL217"
];